export default "<div id=\"react-component--delivery-list\"></div>"